var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#000","stroke":"#000","className":"stroke-colored-el fill-colored-el","d":"M1.5 3.5h5v4h-5z","key":0}),React.createElement("path",{"stroke":"#000","className":"stroke-colored-el","d":"M6 3.121C6 1.95 5.105 1 4 1s-2 .95-2 2.121c0 1.172 4 1.172 4 0z","key":1})]));
}

Lock.defaultProps = {"width":"8","height":"8"};

module.exports = Lock;

Lock.default = Lock;
